export const INITIAL_STATE = {
  loading: false,
  wallets: [],
  activeWalletId: null,
  mnemonic: '',
  walletConnectAccounts: [],
  walletConnectChainId: '',
};
